import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import { createClientId, safeGetStorageItem, safeSetStorageItem } from './browserStorage';
import { showToast } from './toast';

const CLIENT_KEY_STORAGE = 'yamatch_submission_client_key';

function getStoredClientKey() {
  let clientKey = safeGetStorageItem(CLIENT_KEY_STORAGE);
  if (!clientKey) {
    clientKey = createClientId('anon');
    safeSetStorageItem(CLIENT_KEY_STORAGE, clientKey);
  }
  return clientKey;
}

export async function guardContentSubmission({
  action,
  contentType,
  texts = [],
  metadata = {},
  captchaToken = '',
}) {
  const callable = httpsCallable(functions, 'guardContentSubmission', { timeout: 30000 });
  const response = await callable({
    action,
    contentType,
    texts,
    metadata,
    clientKey: getStoredClientKey(),
    captchaToken,
  });
  return response.data;
}

export function showModerationWarning(result) {
  if (result?.flagged && result.warningMessage) {
    showToast({ message: result.warningMessage, type: 'warning', duration: 6000 });
  }
}
